import { createAsyncStore } from "../../utils/createAsyncStore";
import { EventDTO } from "./dto";

export const useEventsAsyncStore = createAsyncStore<EventDTO[]>({
  defaultValue: undefined,
  debugName: "events",
});
